import axios from '../shared/axios';
import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";
import * as events from './events';
import SystemHelper from "../shared/systemHelper";

export function createProjectOrder(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/ProjectOrder/Create`, data)
            .then(result => {
                events.onNotification_CREATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function updateProjectOrder(data) {
    return new Promise((resolve, reject) => {
        axios.put(`/api/ProjectOrder/Update`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function getProjectOrder(projectorderid) {
    return axios.get(`/api/ProjectOrder/GetProjectOrder?earlyprojectorderid=${projectorderid}`);
}

// export function getProjectOrdersReduced(companyid, projectid, contractid, accessibleWfIds) {
//     return axios.post(`/api/ProjectOrder/RegisterList`, { accessibleWfIds }, { params: { companyid, projectid, contractid } });
// }

export function getProjectOrdersToSelectList(contractid) {
    return axios.get(`/api/ProjectOrder/ToSelectList`, { params: { contractid } });
}

export function deleteProjectOrderDraft(projectorderid) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/ProjectOrder/DeleteDraft?projectorderid=${projectorderid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}

export function importProjectOrders(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/ProjectOrder/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteProjectOrderDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/ProjectOrder/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateProjectOrderDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/ProjectOrder/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function getProjectOrderReduced2(companyid, projectid, contractid, showDrafts, accessibleWfIds) {
    return axios.post(`/api/ProjectOrder/RegisterListV2`, {
        showDrafts: showDrafts,
        showRelations: process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true',
        showTags: process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true',
        showCustomFields: SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.CUSTOM_FIELDS_ENABLED),
        excludeTagHeaders: true,
        accessibleWfIds
    },
        { params: { companyid, projectid, contractid } });
}
export function getProjectOrderPackagedList(contractid) {
    return axios.get(`/api/ProjectOrder/RegisterPackagedList`,{ params: {  contractid } });
}